import { Col, Modal, Row, Space, Typography } from "antd";
import { useCallback, useEffect } from "react";
import SuccessIcon from "../../assets/images/icon/successIcon.svg";
const { Title, Text } = Typography;

const SuccessModal = ({ open, setOpen, subTitle, title }) => {
  const handleCancel = () => {
    setOpen(false);
  };

  const countDownToCloseModal = useCallback(() => {
    let secondsToGo = 4;
    setTimeout(() => {
      setOpen(false);
    }, secondsToGo * 1000);
  }, [setOpen]);

  useEffect(() => {
    countDownToCloseModal();
  }, [countDownToCloseModal, open]);

  return (
    <Modal
      centered
      open={open}
      onCancel={handleCancel}
      footer={false}
      width={400}
    >
      <Space
        direction="horizontal"
        style={{
          width: "100%",
          justifyContent: "center",
          marginTop: 30,
        }}
      >
        <img src={SuccessIcon} width={80} alt="Close Icon" />
      </Space>

      <Row justify="center" style={{ marginBottom: 30 }}>
        <Col span={24} align="center">
          <Title level={5}>{title}</Title>
        </Col>
        <Col span={24} align="center">
          <Text className="sub-title">{subTitle}</Text>
        </Col>
      </Row>
    </Modal>
  );
};

export default SuccessModal;
